/**
 * The server's reason for refusing a request, as text.
 *
 * FastAPI sends `detail` as a STRING for an HTTPException and as a LIST
 * of objects for a request that failed validation (422). Rendering that
 * list as a React child throws, and with no error boundary the whole app
 * goes blank -- which is how a too-short new password once read as
 * "the change did not happen" with nothing on screen saying why.
 */
export function errorDetail(err: unknown, fallback: string): string {
  const detail = (err as { response?: { data?: { detail?: unknown } } } | null)
    ?.response?.data?.detail;
  if (typeof detail === "string" && detail) return detail;
  if (Array.isArray(detail)) {
    const first = detail[0] as { msg?: unknown } | undefined;
    if (typeof first?.msg === "string" && first.msg) return first.msg;
  }
  return fallback;
}

/**
 * The server's password policy, mirrored so a form can say what is wrong
 * before posting. `backend/app/auth/passwords.py` is the authority;
 * `errors.test.ts` reads it and fails if these drift apart.
 */
export const PASSWORD_MIN_LENGTH = 10;

export function passwordPolicyProblem(pw: string): string | null {
  if (pw.length < PASSWORD_MIN_LENGTH) {
    return `Must be at least ${PASSWORD_MIN_LENGTH} characters.`;
  }
  if (!/[A-Z]/.test(pw)) return "Must contain an uppercase letter.";
  if (!/\d/.test(pw)) return "Must contain a digit.";
  return null;
}
